import React, { useState } from "react";
import ChapterListLayout from "./ChapterListLayout";
import AddChapterFormWrapper from "../../Chapters/Add/AddChapterFormWrapper";
import { useParams } from "react-router-dom";

type Props = {
  allchapters: any;
  chaptersIsLoading: any;
};

const ChapterListLayoutWrapper = ({
  allchapters,
  chaptersIsLoading,
}: Props) => {
  const [isOpenAddFormDialog, setIsOpenAddFormDialog] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  //GET MODULE ID
  const {moduleId} = useParams()

  return (
    <>
     
     <ChapterListLayout
        featureIsLoading={chaptersIsLoading}
        listHeading={"Chapters"}
        onAddClick={() => {
          setIsOpenAddFormDialog(true);
        }}
        OnSearchChange={setSearchValue}
        searchValue={searchValue}
        listData={allchapters}
        disabled={false}
      />
      {isOpenAddFormDialog ? (
         <AddChapterFormWrapper
          moduleId={moduleId}
          onClose={() => setIsOpenAddFormDialog(false)}
        />
      ) : null} 
    </>
  );
};

export default ChapterListLayoutWrapper;
